import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { HcaUserManagementService } from '../../../../../../shared/_services/hca-user-management.service';
import { ValidationService } from '../../../../../../shared/_services/validation.service';
import { HotelManagementService } from '../../../../../../shared/_services/hotel-management.service';
import { Subject } from 'rxjs';
import { UtilService } from '../../../../../../shared/_services/util.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../../../../../../shared/_services/http.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { environment } from '../../../../../../../environments/environment';
import { ImageFile } from '../../../../../../shared/_data-model/image-file';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { IDayCalendarConfig } from 'ng2-date-picker';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';


@Component({
  selector: 'app-hotels-add',
  templateUrl: './hotels-add.component.html',
  styleUrls: ['./hotels-add.component.scss']
})
export class HotelsAddComponent implements OnInit {
  previousRoute: any;
  dateRepeated: boolean = false;
  isDatesRepeated: boolean = false;
  disabled: boolean = false;
  successMsg: string;
  isNewHotel: boolean;
  hotelId: number;
  //imageFile: any;
  hotel: any = FormGroup;
  tagInputText: any;
  hotelBrands: any[];
  programTypes: any[];
  bsModalRef: BsModalRef;
  searchTerm$ = new Subject<string>();
  errorDetails: string;
  errorUpload: boolean;
  items = [];
  hotelTags: (text: string) => Observable<Response>;
  bsConfig: Partial<BsDatepickerConfig> = { containerClass: 'theme-orange' };
  imageFile: ImageFile = new ImageFile;
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('uploadFile') uploadFile: any;
  myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    editableDateField: false,
    inline: false,
    disableUntil: {year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1},
    openSelectorOnInputClick: true
  };
  fileSizeError: any;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpService,
    private location: Location,
    private validationService: ValidationService,
    private modalService: BsModalService,
    private utilService: UtilService,
    private hotelManagementService: HotelManagementService,
    private hcaUserManagementService: HcaUserManagementService,
    private loyaltyService: LoyaltyService
  ) {
    this.hotelTags = (text: string): Observable<Response> => {
      const url = `/hotel/getHotelTags/hotel/${text}`;
      return this.http
        .get(url).debounceTime(300)
        .distinctUntilChanged()
        .map(data => {
          if (data.json().error == 0) {
            if (data.json().responseObj.length) {
              return data.json().responseObj
            } else {
              this.tagInputText = "";
            }
          }
        });
    }

    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "hca-image") {
              this.imageFile.imageUrl = "";
              this.imageFile.name = "";
              this.imageFile.file = null;
              this.hotel.get('banner').setValue('', {emitEvent: false});
            }
            else if (this.statusModal.content.srcObject.type == "hotel-add") {
              if(this.hotel.value && this.hotel.value.brandId) {
                let selectedBrand = this.hotelBrands.filter(brand => brand.brandId == parseInt(this.hotel.value.brandId));
                this.hotelManagementService.setSelectedBrand(selectedBrand[0]);
              }
              // this.router.navigate(['/hotel-management']);
              this.location.back();
              // window.history.back();
            } else if (this.statusModal.content.srcObject.type == "hca-remove") {
              const form = this.statusModal.content.srcObject.form;
              const control = this.statusModal.content.srcObject.control;
              const i = this.statusModal.content.srcObject.i;
              const type = this.statusModal.content.srcObject.type2;
              this.removeControl(form, control, i, type);
            }

          }
        }
      })
  }

 

  confirmClose() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hotel-add',
      title: 'Confirm',
      message: this.isNewHotel ? "Are you sure you want to cancel creation of a hotel?" : "Are you sure you want to cancel modifying a hotel?",
      action1: 'Yes',
      action2: 'No',
      action: '',
      style: 'active'
    }
  }

  //TODO - for search tags
  //  searchChanges(){
  //   this.utilService.search(`/hotel/getHotelTags`, this.searchTerm$)
  //   .subscribe(results => {
  //     if(results.error == 0) {
  //       this.hotelTags = results.responseObj;
  //     } else{
  //       this.hotelTags = [];
  //     }
  //   });
  // }
  uploadImage(event: any) {
    this.imageFile = this.utilService.uploadImage(event);
    this.errorUpload = this.imageFile.errorUpload;
    this.fileSizeError = this.imageFile.fileSizeError;
    if(this.errorUpload || this.fileSizeError) {
      this.imageFile.file = null;
      this.imageFile.imageUrl = '';
      this.imageFile.name = '';
    }
    this.resetFileInput('uploadFile');
    setTimeout(() => {
    this.errorUpload = false;
    this.fileSizeError = false;
    }, 1500);
  }

  resetFileInput(element?) {
    this[element].nativeElement.value = "";
  }

  onDateChanged(event: IMyDateModel, type, i) {
    let seasonForm = this.hotel.get('seasonsList') as FormArray;
    seasonForm.at(i).get(type).setValue(event.formatted);
    seasonForm.at(i).get(type).markAsDirty();
    seasonForm.at(i).get(type).markAsTouched();
  }

  getForm(data) {
    let keys = ['dateFrom', 'dateTo'];
    let listType = 'seasonsList';
    // let formattedDate = this.utilService.parseDate(data.value, listType, keys);
  }
  // fileChanged(event: any) {
  //   let image = URL.createObjectURL(event.target.files[0]);
  //   let fileList: FileList = event.target.files;
  //   // this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(image); 
  //   //this.loginService.profileInfo(this.imageUrl);
  //   this.imageFile = event.target.files[0];
  //   this.errorUpload = false;
  //   if (fileList.length > 0 && (this.imageFile.type === 'image/png' || this.imageFile.type === 'image/jpg' || this.imageFile.type === 'image/jpeg')) {
  //     this.errorUpload = false;
  //   } else {
  //     this.errorUpload = true;
  //   }
  // }

  onSelect(item) {
    this.items.push(item);
  }

  getHotelBrandsByHotelChain() {
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
      res => {
        if (res.error == 0) {
          this.hotelBrands = res.responseObj;
        }
        else {
          console.error("Get Hotel Brands : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }

  addHotel(data) {
    this.disabled = true;
    this.successMsg = "";
    if (!this.isNewHotel) {
      data.value.hotelId = this.hotelId;
    }
    let formData: any = new FormData()
    formData.append('hotelData', JSON.stringify(this.utilService.parseDate(data.value, 'seasonsList', ['dateFrom', 'dateTo'])));
    if (this.imageFile && this.imageFile.file) {
      formData.append('hotelBanner', this.imageFile.file, this.imageFile.file.name);
    } else {
      var file = new Blob([], { type: 'image/jpg' });
      formData.append('hotelBanner', file, null);
    }
    this.hotelManagementService.addHotelForBrand(formData, this.isNewHotel).subscribe((res) => {
      if (res.error == 0) {
        if(this.previousRoute.indexOf('employees') == -1) {
          let selectedBrand = this.hotelBrands.filter(brand => brand.brandId == parseInt(data.value.brandId));
          //localStorage.setItem('selectedBrandObj', JSON.stringify(selectedBrand[0]));
          this.hotelManagementService.setSelectedBrand(selectedBrand[0]);
        }
        this.successMsg = this.isNewHotel ? "Hotel has been added successfully" : "Changes made successfully";
        setTimeout(() => {
          // this.router.navigate(['/hotel-management']);
          this.location.back();
          this.successMsg = "";
          this.disabled = false;
        }, 1500);
      } else {
        this.disabled = false;
        //this.errorDetails = res.message;
        this.errorDetails = this.isNewHotel ? "Error while creating hotel" : "Error while updating hotel";
      }
    }, error => {
      this.disabled = false;
      this.errorDetails = error.message;
      console.log('========res ===========', error);
    })
  }

  getHotelDetails(hotelId) {
    this.hotelManagementService.getHotelInfo(hotelId).subscribe(
      res => {
        if (res.error == 0) {
          this.imageFile = new ImageFile;
          this.imageFile.name = res.responseObj.banner;
          this.imageFile.imageUrl = res.responseObj.banner && res.responseObj.banner.indexOf('/home/ubuntu') == -1 ? `${environment.BASE_IMAGE_API}/images/hotels/${res.responseObj.hotelId}/${res.responseObj.banner}` : ``;
          res.responseObj.seasonsList = res.responseObj.seasonsList ? res.responseObj.seasonsList : [];
          this.initForm(res.responseObj);
          //this.hotel.patchValue(res.responseObj);
        } else {
          console.error("Get Hotel Chain Admin Details : " + res);
        }
      }, error => {
        console.error(error.message);
      });
  }

  getProgramTypes() {
    this.loyaltyService.getProgramTypes().subscribe(
      res => {
        if (res.error == 0) {
          this.programTypes = res.responseObj;
        }
        else {
          console.error("Get Program Types : " + res.message);
        }
      }, err => {
        console.error(err);
      }
    );
  }

  addSeason(seasonData?: any) {
    let seasonForm = this.hotel.get('seasonsList') as FormArray;
    seasonForm.push(this.fb.group({
      seasonId: [seasonData ? seasonData.seasonId : ''],
      name: [seasonData ? seasonData.name : '', Validators.required],
      dateTo: [seasonData ? seasonData.dateTo : '', Validators.required],
      dateFrom: [seasonData ? seasonData.dateFrom : '', Validators.required],
      points: [seasonData ? seasonData.points : '', Validators.required],
      programId: [seasonData ? seasonData.programId : '', Validators.required],
      // }, {validator: this.validationService.checkDateRange}))
    }))
  }

  removeControl(form, control, i, type?) {    
      const formControl = <FormArray>this[form].controls[control];      
      formControl.removeAt(i);    
  }

  initForm(hotelData?: any) {
    let seasonsList: FormArray = new FormArray([], Validators.compose([this.validationService.minLengthArray(1), this.validationService.uniqueBy('name'), this.validationService.checkDateRange.bind(this), this.validationService.dateValidator.bind(this)]));
    this.hotel = this.fb.group({
      hotelName: [hotelData ? hotelData.hotelName : '', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(60)])],
      // contactEmail: [hotelData ? hotelData.contactEmail : '', Validators.compose([Validators.required, Validators.pattern(this.validationService.email_regexPattern)])],
      contactEmail: [hotelData ? hotelData.contactEmail : '', Validators.compose([Validators.required])],
      hotelCode: [hotelData ? hotelData.hotelCode : '', Validators.required],
      brandId: [hotelData ? hotelData.brandId : '', Validators.required],
      banner: [hotelData ? hotelData.banner : ''],
      description: [hotelData ? hotelData.description : ''],
      website: [hotelData ? hotelData.website : '', Validators.compose([Validators.pattern(this.validationService.webUrl_regexPattern)])],
      voucherEmailId: [hotelData ? hotelData.voucherEmailId : ''],
      tags: [hotelData ? hotelData.tags : ''],
      seasonsList: seasonsList,
    });
    if (!hotelData || hotelData.seasonsList.length < 1) {
      this.addSeason();
    } else {
      hotelData.seasonsList.forEach(season => {
        season.dateFrom = season.dateFrom ? { formatted: this.utilService.dateFormat(season.dateFrom, 'MM/DD/YYYY') } : null
        season.dateTo = season.dateTo ? { formatted: this.utilService.dateFormat(season.dateTo, 'MM/DD/YYYY') } : null
        this.addSeason(season);
      })
    }
  }

  deleteImage() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-image',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to delete this image?',
      action1: 'Yes',
      action2: 'No',
      action: '',
    }
  }

  remove(form, control, i, type2?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-remove',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to remove season?',
      action1: 'Remove',
      action2: 'Cancel',
      action: '',
      style: 'inactive',
      form: form,
      control: control,
      i: i,
      type2: type2
    }
  }

  

  ngOnInit() {
    this.getHotelBrandsByHotelChain();
    //this.hotelTags = [{"hotelTagId": 1, "name": 'sandos brand1'}, {"hotelTagId": 2, "name": 'sandos brand2'}, {"hotelTagId": 3, "name": 'sandos brand3'}];
    this.route.params.subscribe(params => {
      this.hotelId = +params['id']; // (+) converts string 'id' to a number
      if (this.hotelId) {
        this.isNewHotel = false;
        this.initForm();
        this.getHotelDetails(this.hotelId);
        this.getProgramTypes();
      } else {
        this.isNewHotel = true;
        this.initForm();
      }
    });
    this.previousRoute = this.utilService.getPreviousRoute;
    this.hotel.controls['seasonsList'].valueChanges
      .subscribe(value => {
      })
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/hotels/hotel-management/hotels-add/hotels-add.component.ts